import { sdkRequest } from '@eventbrite/legacy-infra.http';
import { LocationRequest } from '../types';

const GET_PLACE_FROM_IP = '/api/v3/geo/place_from_request/';

export const getPlaceFromRequest = (): Promise<LocationRequest> => {
    return sdkRequest(GET_PLACE_FROM_IP);
};
